import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import {labels} from '../../../util/utils';

import {IconoirWarningCircle} from '@ey-xd/motif-icon';
import MotifErrorMessage from '@ey/motif-react-wrapper/ErrorMessage';
import MotifFormField from '@ey/motif-react-wrapper/FormField';
import MotifInput from '@ey/motif-react-wrapper/Input';
import MotifLabel from '@ey/motif-react-wrapper/Label';
import MotifIcon from '@ey/motif-react-wrapper/Icon';

const Input = ({label = null, errorMessage = null, className = null, labelPosition = 'in', ...rest}) => {
	const renderLabel = () => <MotifLabel position={labelPosition}>{label}</MotifLabel>;

	const renderError = () => <MotifErrorMessage>{errorMessage}</MotifErrorMessage>;

	const props = {
		...rest,
		clearButtonTitle: labels.clear,
		labelPosition
	};

	if (errorMessage) props.suffix = <MotifIcon fill="var(--red-600)" size="20" src={IconoirWarningCircle} />;

	return (
		<MotifFormField className={classNames('no-min-width', {[`${className}`]: className})}>
			{label && renderLabel()}
			<MotifInput {...props} />
			{errorMessage && renderError()}
		</MotifFormField>
	);
};

Input.propTypes = {
	label: PropTypes.string,
	errorMessage: PropTypes.string,
	className: PropTypes.string,
	labelPosition: PropTypes.oneOf(['in', 'out'])
};

export default Input;
